<div class="header-bar">
    <div class="header-left">
        <div class="header-text">Key Metrics</div>
    </div>
    <div class="header-center">

        <div class="apps">
            <div class="input-box">
                <mat-form-field class="select-form" [formGroup]="filterForm">
                    <mat-label *ngIf="apps.length"
                        >Apps</mat-label
                    >
                    <mat-label *ngIf="!apps.length"
                        >No Apps To Select</mat-label
                    >
                    <mat-select formControlName="apps" multiple [(value)]="selectedApps">
                        <mat-option
                        class="mat-lightGreen"
                        *ngFor="let app of apps"
                        [value]="app"
                        
                        >{{ app.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="divider"></div>
        <div class="dates">
            <div class="date start-date">
                <div class="text">Start</div>
                <button mat-button class="icon-btn" (click)="startDatePicker.openPicker()">
                    <svg-icon src="assets/svg/calendar.svg" [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }" svgClass="grey">
                    </svg-icon>
                </button>
                <lhpe-datepicker #startDatePicker [hideToggle]="true" placeholder="mm/dd/yyyy" [formGroup]="filterForm"
                    controlName="startDate">
                </lhpe-datepicker>
            </div>
            <div class="date end-date">
                <div class="text">End</div>
                <button mat-button class="icon-btn" (click)="endDatePicker.openPicker()">
                    <svg-icon src="assets/svg/calendar.svg" [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }" svgClass="grey">
                    </svg-icon>
                </button>
                <lhpe-datepicker #endDatePicker [hideToggle]="true" placeholder="mm/dd/yyyy" [formGroup]="filterForm"
                    controlName="endDate">
                </lhpe-datepicker>
            </div>
        </div>
        <div class="divider"></div>
        <lhpe-select
            controlName="group"
            placeholder="Period"
            [formGroup]="filterForm"
            [options]="periods"
            displayValue="label"
            [optionIsSelf]="true"
            >
        </lhpe-select>

    </div>
    <div class="header-right">
        <button mat-icon-button [matMenuTriggerFor]="redemptionsMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant" #redemptionsMenu="matMenu">
            <button class="icon-btn-w-text" mat-menu-item (click)="update(true)">
                <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>

                <span>Export to Excel</span>
            </button>
        </mat-menu>
        <button
            mat-button
            color="lightGreen"
            (click)="update(false)"
            [disabled]="!canUpdate"
            >
            Update
        </button>
    </div>
</div>

<div class="stats">
    <div class="container stats-container">
        <div class="container-content">

            <table *ngIf="this.data.length>0">
                
                <thead>
                    <tr>
                        <th></th>
                        <th *ngFor="let item of this.data[0].data;">{{ periodLabel(item.period) }}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody *ngFor="let group of this.data;">

                    <tr>
                        <td class="label">
                            <strong>{{group.name}}</strong>
                        </td>
                        <td *ngFor="let item of group.data;" class="data"></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td class="label">Installs</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.installs }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Locations Tracked</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.locations_tracked }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Auto-Signals Sent</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.auto_signals_sent }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Auto-Signals Read</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.auto_signals_read }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Auto-Signal Conversions</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.auto_signal_coversions }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Broadcasts Sent</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.quick_signals_sent }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Broadcast Recipients</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.quick_signal_recipients }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Broadcasts Read</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.quick_signals_read }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Broadcast Conversions</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.quick_signal_conversions }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. Unknown (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_null }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. Not Determined (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_0 }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. Restricted (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_1 }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. Denied (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_2 }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. Always (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_3 }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Loc. Perm. When In Use (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_location_perm_4 }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Push Perm. Unknown (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_push_perm_null }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Push Perm. Granted (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_push_perm_true }}</td>
                        <td></td>
                    </tr>
    
                    <tr>
                        <td class="label">Push Perm. Denied (Cumulative)</td>
                        <td *ngFor="let item of group.data;" class="data">{{ item.sum_push_perm_false }}</td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                </tbody>
                

            </table>

        </div>
    </div>
</div>